import React from 'react';
import { useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import Topbar from './Topbar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const location = useLocation();
  
  const getPageTitle = (pathname: string): string => {
    switch (pathname) {
      case '/app/dashboard':
        return 'Dashboard';
      case '/app/pipeline':
        return 'Pipeline';
      case '/app/lead-gen/place-request':
      case '/app/lead-gen/requests':
      case '/app/lead-gen/pre-qualified':
      case '/app/lead-gen/qualified':
        return 'Lead Gen Agent';
      case '/app/call-agent':
        return 'Call Agent';
      case '/app/whatsapp-agent':
        return 'WhatsApp Agent';
      case '/app/email-agent':
        return 'Email Agent';
      case '/app/linkedin-agent/outreach':
      case '/app/linkedin-agent/post-comment':
        return 'LinkedIn Agent';
      case '/app/meetings':
        return 'Meetings';
      case '/app/settings':
        return 'Settings';
      default:
        return 'AI Sales Platform';
    }
  };

  return (
    <div className="h-screen flex bg-gray-50">
      <Sidebar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <Topbar pageTitle={getPageTitle(location.pathname)} />
        <main className="flex-1 overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;